<template>
	<nav
		@mouseover="logoChange('black')"
		@mouseout="logoChange('white')"
		v-bind:class="[
			{
				affected: scrollPosition > 68,
				is_logged_in: is_logged_in,
			},
			'menu_sec',
		]"
		style="background-color: transparent; box-shadow: none; border-bottom: none"
	>
		<div class="container-box">
			<div class="navbar">
				<div v-if="logo_routing && logo_routing.name === 'home'">
					<a href="/">
						<img :src="currentLogo" alt="logo" />
					</a>
				</div>
				<div v-else>
					<router-link v-bind:to="logo_routing">
						<img :src="currentLogo" alt="logo" />
					</router-link>
				</div>
				<slot></slot>
			</div>
			<div id="menu_auth" class="head_btn_sec">
				<menu-lang></menu-lang>
				<menu-auth v-if="!is_logged_in"></menu-auth>
				<menu-my
					v-if="is_logged_in"
					v-bind:is_logged_in="is_logged_in"
					@showMerchantPicker="merchantSelectModal = true"
					@showTutorial="showTutorial = true"
				></menu-my>
			</div>
		</div>
	</nav>

	<ModalView
		add-class="merchant"
		v-if="merchantSelectModal"
		@closeModal="merchantSelectModal = false"
	>
		<MerchantPicker
			@selectMerchant="selectMerchant"
			@closeModal="merchantSelectModal = false"
		></MerchantPicker
	></ModalView>
	<Tutorial v-if="showTutorial" @close="showTutorial = false"></Tutorial>
</template>

<script>
import { mapGetters } from 'vuex';
import menuAuth from '@/components/Menu/Auth';
import menuMy from '@/components/Menu/My';
import MenuLang from '@/components/Menu/Lang';
import ModalView from '@/components/Layout/ModalView';
import Tutorial from '@/components/Tutorial';
import { defineAsyncComponent } from 'vue';

export default {
	name: 'Header',
	components: {
		MenuLang,
		menuAuth,
		menuMy,
		ModalView,
		Tutorial,
		MerchantPicker: defineAsyncComponent(() =>
			import('@/components/Merchant/MerchantPicker.vue'),
		),
	},
	data() {
		return {
			scrollPosition: 0,
			merchantSelectModal: false,
			showTutorial: false,
			logoImg: {
				white: require('@/assets/images/v2/logo.svg'),
				black: require('@/assets/images/v2/logo.svg'),
			},
			currentLogo: require('@/assets/images/v2/logo.svg'),
		};
	},
	computed: {
		...mapGetters('auth', ['is_logged_in']),
		logo_routing() {
			if (this.is_logged_in) {
				if (this.$store.state.common.isMerchant) {
					if (!this.$route.params.merchant_seq) {
						return { name: 'auth-dashboard' };
					} else {
						return { name: 'merchant-console-catalog', ...this.$route.params };
					}
				} else {
					return { name: 'auth-dashboard' };
				}
			} else return { name: 'home' };
		},
	},
	watch: {
		is_logged_in() {
			this.$forceUpdate();
		},
	},
	created() {
		this.currentLogo =
			this.$route.name === 'home' ? this.logoImg.white : this.logoImg.black;
	},
	methods: {
		updateScroll() {
			this.scrollPosition = window.scrollY;
			if (this.$route.name === 'home') {
				this.currentLogo =
					this.scrollPosition > 68 ? this.logoImg.black : this.logoImg.white;
			} else {
				this.currentLogo = this.logoImg.black;
			}
		},
		logoChange(state) {
			if (this.$route.name === 'home') {
				if (this.scrollPosition > 68) return;
				this.currentLogo = this.logoImg[state];
			} else {
				this.currentLogo = this.logoImg.black;
			}
		},
		selectMerchant(obj) {
			this.toRoute(obj);
			this.$store.dispatch('auth/getMerchantInfo', obj.params.merchant_seq);
			this.modalMerchant = false;
		},
		toRoute(obj) {
			// this.isMenuOpen = false;
			this.$router.push(obj);
		},
	},
	mounted() {
		window.addEventListener('scroll', this.updateScroll);
	},
};
</script>
